<template>
	<div class="component-networks" :class="{ 'on-scroll': offsetTop > 800, 'on-scrol-footer' : offsetTop > 4090, 'responsive-none' : offsetTop > 9000}">
		<v-flex text-xs-center class="border-bottom" v-for="(item, index) in links" :key="index">
				<a :href="item.link" target="_blank" class="link-networks">
					<img :src="item.icon" alt="" :style="`width: ${item.width}px`">
				</a>
		</v-flex>
	</div>
</template>

<script>
export default {
	name: 'component-icon-networks',
	props: {
		links: {
			type: Array,
			default: () => [],
		},
		offsetTop: [String, Number],
		windowSize: {
			default: () => {},
			type: Object,
		},
	},
};
</script>
<style lang="scss" scoped>
.component-networks {
	background-color: map-get($colors, base);
	border-bottom-left-radius: 12px;
	border-top-left-radius: 12px;
	padding: 0 9px;
	position: absolute;
	top: 114px;
	right: 0;
	width: 50px;

	&.on-scroll:not(.open) {
		transition: all 0.55s 0.05s ease;
		position: fixed;
		z-index: 45;
	}

	&.on-scrol-footer:not(.open) {
		background-color: map-get($colors, base);
		transition: all 0.55s 0.05s ease;
		position: fixed;
		top: 500px;

		@media (max-width: 1024px) {
			display: none;
		}
	}

	&.responsive-none:not(.open) {
		display: none;
	}
}

.border-bottom {
	border-bottom: 1px solid map-get($colors, white);
	padding: 16px 0;

	&:last-child {
		border-bottom: none !important;
	}
}

.link-networks {
	cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/home/component-icon-networks.vue